module.exports = __webpack_public_path__ + "img/k8s2.25351fea.svg";